import type { MediaTimelineBarProps, MediaTimelineTrack } from "./timelineTypes";

export interface TimelineNavigationRegion {
  firstIndex: number;
  lastIndex: number;
  firstTrackId: string;
  lastTrackId: string;
  label: string;
  gapBefore: boolean;
}

/** Appearance controls surface seams; overlay eligibility is independent of type and density. */
export function resolveTimelineTrackLayout(
  tracks: readonly Pick<MediaTimelineTrack, "id" | "type" | "label" | "navigationOverlay">[],
  appearance: MediaTimelineBarProps["trackAppearance"],
) {
  const rows = tracks.map((track, index) => {
    const surface = track.type !== "markers";
    const previous = tracks[index - 1];
    const next = tracks[index + 1];
    const joinBefore =
      appearance === "joined" && surface && previous !== undefined && previous.type !== "markers";
    const joinAfter =
      appearance === "joined" && surface && next !== undefined && next.type !== "markers";
    return { joinBefore, joinAfter, gapBefore: index > 0 && !joinBefore };
  });
  const navigationRegions: TimelineNavigationRegion[] = [];
  tracks.forEach((track, index) => {
    if (!(track.navigationOverlay ?? track.type !== "markers")) return;
    const previous = navigationRegions[navigationRegions.length - 1];
    if (previous?.lastIndex === index - 1) {
      previous.lastIndex = index;
      previous.lastTrackId = track.id;
    } else {
      navigationRegions.push({
        firstIndex: index,
        lastIndex: index,
        firstTrackId: track.id,
        lastTrackId: track.id,
        label: track.label ?? track.id,
        gapBefore: rows[index]?.gapBefore ?? false,
      });
    }
  });
  return { rows, navigationRegions };
}
